<template>
  <div class="map">
    <p class="title">用户分布</p>
    <div id="map_container"></div>
    <!-- 左下角图例 -->
    <div class="tooltips">
      <div v-for="(item, index) in filterData" :key="item.portrayalId"><span :class="`icon_${index + 1}`"></span><span>{{item.name}}</span></div>
      <div><img :src="gas_icon" class="gas_icon" alt=""><span>本油站</span></div>
    </div>
    <!-- 右上角按钮 -->
    <div class="set-zoom_button">
      <div @click="changeUp">放大 <i class="el-icon-plus"></i></div>
      <div @click="changeDown">缩小 <i class="el-icon-minus"></i></div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask_layer"></div>
  </div>
</template>
<script>
import { getUserMap } from '@/api/businessAnalysis'
import variables from '../style/map.less'
import Vue from 'vue/dist/vue.esm.js'
import remoteLoad from '@/utils/remoteLoad.js'
const gas_icon = require('../../../assets/image/icon/icon-station-address.png')

export default {
  props: ['oilStation'],
  data () {
    return {
      gas_icon,
      map: null,
      portrayalUserDistributionList: [],
      distanceType: 10, // 用户范围
      center: [], // 油站位置
      filterData: [], // 展示5km或10km的点
    }
  },
  methods: {
    initMap() {
      // eslint-disable-next-line no-undef
      this.map = new AMap.Map('map_container', {
        resizeEnable: true,
        zoomEnable: false,
        zoom: 12
      })

      if (this.oilStation) this.initData()
    },
    // 初始化数据
    async initData () {
      const { code, result } = await getUserMap({ gasId: this.oilStation })
      if (code !== 200) return
      const { gasLongitude, gasLatitude, portrayalUserDistributionList } = result
      this.portrayalUserDistributionList = portrayalUserDistributionList
      this.center = [gasLongitude, gasLatitude]
      this.map.setZoomAndCenter(12, this.center)
      this.addLayers()
    },
    // 增加覆盖物
    addLayers () {
      this.map.clearMap()
      this.addGasMarker()
      this.addUserMarker()
    },
    // 增加油站覆盖物
    addGasMarker () {
      // 设置范围
      // eslint-disable-next-line no-undef
      let circle = new AMap.Circle({
        center:this.center,
        radius:this.distanceType*1000,// 范围，单位米
        strokeColor:'white',
        strokeWeight:1,
        strokeOpacity:0.1,
        fillColor:'rgba(0,0,255,1)',
        fillOpacity:0.1,
        cursor:'pointer',
        clickable: false
      })

      // 设置油站覆盖物
      // eslint-disable-next-line no-undef
      let icon = new AMap.Icon({
        // eslint-disable-next-line no-undef
        imageSize: new AMap.Size(17, 24),
        image: this.gas_icon,
      })

      // eslint-disable-next-line no-undef
      let marker = new AMap.Marker({
        position: this.center,
        icon: icon
      })

      this.map.add([marker, circle])
    },
    // 增加用户覆盖物
    addUserMarker () {
      // 根据距离筛选数据
      this.filterData = this.portrayalUserDistributionList.filter(item => item.distanceType === this.distanceType).map((item, i) => Object.assign({ $color_id: i + 1 }, item))

      const _this = this
      let userMarkerList = []
      this.filterData.map(item => {
        item.userDetail.map(subItem => {
          let center = [subItem.longitude, subItem.latitude];
          // eslint-disable-next-line no-undef
          let circleMarker = new AMap.CircleMarker({
            center:center,
            radius:6,
            strokeColor: variables[`color_${item.$color_id}`],
            strokeWeight:1,
            fillColor: variables[`color_${item.$color_id}`],
            zIndex:100,
            bubble:true,
            cursor:'pointer'
          })
          circleMarker.on('click', function () {
            let infoContent = Vue.extend({
              template: `<div style="min-width: 140px">
                <div style="padding: 12px 10px;color: #1E1E28;">${item.recommendDesc}</div>
                <button class="button" v-if="item.canSend" @click="sendCoupon">去发券</button>
              </div>`,
              data () {
                return {
                  item: item
                }
              },
              methods: {
                sendCoupon () {
                  _this.$track.clickEvent('经营分析-去发券按钮', 1655798953)
                  _this.$router.push({ path: '/vipMarket/sendCoupon', query: { gasId: _this.oilStation, portrayalId: item.portrayalId, groupId: item.groupId, id: item.crowId, target: item.target, source: 'map' } })
                }
              }
            })

            // eslint-disable-next-line no-undef
            let infoWindow = new AMap.InfoWindow()
            let component = new infoContent().$mount()
            infoWindow.setContent(component.$el)
            infoWindow.open(_this.map, center)
            infoWindow.on('close', function () {
              // 清理垃圾，防止栈溢出
              component = null
              infoContent = null
            })
          })
          userMarkerList.push(circleMarker)
        })
      })
      this.map.add(userMarkerList)
    },
    changeUp () {
      if (this.distanceType === 5) return
      this.distanceType = 5
      this.addLayers()
      this.map.setZoomAndCenter(13, this.center)
      this.$track.clickEvent('经营分析-地图放大按钮', 1655798955)
    },
    changeDown () {
      if (this.distanceType === 10) return
      this.distanceType = 10
      this.addLayers()
      this.map.setZoomAndCenter(12, this.center)
      this.$track.clickEvent('经营分析-地图缩小按钮', 1655798956)
    }
  },
  watch: {
    oilStation (val) {
      if (val) this.initData()
    }
  },
  mounted () {
    // 已载入高德地图API，则直接初始化地图
    if (window.AMap && window.AMapUI) {
      this.initMap()
      // 未载入高德地图API，则先载入API再初始化
    } else {
      // 载入高德地图和UI组件
      Promise.all([remoteLoad(`https://webapi.amap.com/maps?v=1.4.15&key=b1b9067f9385e66ecc8c166a158dbec0`), remoteLoad('https://webapi.amap.com/ui/1.0/main.js')]).then(() => {
        this.initMap()
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../style/map.less');
</style>